import * as React from 'react';
import { SelectDesktop } from '@cian/ui-kit/select';
import { Header1, Header4 } from '@cian/ui-kit/typography';

import { ERoomsCount, IRoomsCountsByHouse, ILayout } from '../../types/newbuilding/layouts';
import { getHouseInfo } from '../../utils/layouts';
import { Layout } from '../Layout';
import { LayoutsCarousel } from '../LayoutsCarousel';
import { LayoutsPreview } from '../LayoutsPreview';
import { RadioButtonsMultiple } from '../RadioButtonsMultiple/RadioButtonsMultiple';

import * as styles from './styles.css';

interface ILayoutsModalProps {
  houses: IRoomsCountsByHouse[];
  currentHouse: number;
  currentRoom: ERoomsCount | undefined;
  layouts: ILayout[];
  onHouseChange(houseId: number): void;
  onRoomChange(roomsCount: ERoomsCount | undefined): void;
  onOffersButtonClick(): void;
  on3DTourTypeChange(): void;
}

export function Layouts({
  houses,
  currentHouse,
  currentRoom,
  layouts,
  onHouseChange,
  onRoomChange,
  onOffersButtonClick,
  on3DTourTypeChange,
}: ILayoutsModalProps) {
  const [currentLayout, setCurrentLayout] = React.useState(1);
  const house = getHouseInfo(currentHouse, houses);
  const rooms = house?.roomsCountList || [];

  const roomsOptions = rooms.map(room => {
    return {
      value: room.roomValue,
      label: room.roomTitle,
      disabled: !room.isAvailable,
    };
  });
  const housesOptions = houses.map(house => {
    return {
      value: house.houseId || 0,
      label: house.houseName,
    };
  });

  const onHouseItemClick = React.useCallback((id: number) => onHouseChange(id), [onHouseChange]);

  return (
    <Layout>
      <div data-nav-tab="layouts/Планировки" id="layouts" className={styles['nav_container']}>
        <Header1 as={'h2'} fontWeight={'bold'}>
          Планировки
        </Header1>
        <div className={styles['container']}>
          <div className={styles['selectors']}>
            <Header4 fontWeight={'bold'}>Выбрать планировку</Header4>
            {/*Один из корпусов всегда "Все корпуса", поэтому для ЖК с одним корпусом не показываем фильтр по корпусам*/}
            {houses.length > 2 && (
              <div className={styles['selector']}>
                <SelectDesktop options={housesOptions} onChange={onHouseItemClick} value={currentHouse} />
              </div>
            )}
            <div className={styles['selector']}>
              <RadioButtonsMultiple
                initialValue={currentRoom}
                options={roomsOptions}
                name={'name'}
                onClick={onRoomChange}
              />
            </div>
            <div className={styles['selector']}>
              <LayoutsPreview layouts={layouts} selectedLayout={currentLayout} selectLayout={setCurrentLayout} />
            </div>
          </div>
          <div className={styles['layouts']}>
            <LayoutsCarousel
              media={layouts}
              selectedLayout={currentLayout}
              selectLayout={setCurrentLayout}
              onButtonClick={onOffersButtonClick}
              on3DTourTypeChange={on3DTourTypeChange}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
